import { Clickable, H2, P, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

import constants from '../../../../../ahm-constants';

const StyledSection = styled(Section)`
  padding: 0;
  margin-bottom: 2rem;
`;

const CodeOfPractice = () => (
  <StyledSection id="codeOfPractice">
    <H2 variant="marginBottomSpacer10">Our commitment to the Life Insurance Code of Practice</H2>
    <P>
      Hannover, the issuer of ahm Life Insurance products (issued on or before 30 June 2023) has adopted the Life
      Insurance Code of Practice (the Life Code). The Life Code is the life insurance industry’s commitment to mandatory
      customer service standards and it’s designed to protect you, our customer. You can find out more about the Life
      Code <Clickable to={constants.URLS.THIRD_PARTY.LIFE_INSURANCE_CODE_OF_PRACTICE}>here.</Clickable>
    </P>
    <P>
      Among other things, the Life Code sets out how insurers will assess your claim if your Insurance Policy has a
      medical definition which specifies an obsolete method of diagnosis or treatment that is no longer used in
      mainstream medical practice in Australia. Any future improvements we make to medical definitions applicable to
      your Insurance Policy will be made available to you in the event of your need to claim.
    </P>
  </StyledSection>
);

export default CodeOfPractice;
